module.exports = __webpack_public_path__ + "img/cabinet-logo-cab.b0da8b09.png";